import React from 'react';
import PropTypes from 'prop-types';

import './Loader.scss';

const Loader = ({ background, className, containerHeight }) => (
  <div
    className={`Loader ${className}`}
    style={{
      minHeight: containerHeight,
    }}
  >
    <div
      className="loading"
      style={{
        background,
      }}
    />
  </div>
);

Loader.propTypes = {
  background: PropTypes.string,
  className: PropTypes.string,
  containerHeight: PropTypes.string,
};

Loader.defaultProps = {
  background: undefined,
  className: '',
  containerHeight: undefined,
};

Loader.displayName = 'Loader';
export default Loader;
